<template>
	<div id="zhcz">
		<div class="zhcz_main" v-show="!isNoPay">
			<div class="tips">
				<div style="font-size: 16px">温馨提示：</div>
				<div class="tip-text">1、 充值请等待页面自动跳转否则不会自动到账</div>
				<div class="tip-text">
					2、 充值金额必须是创建订单后，系统自动分配给您的金额，如您输入充值金额 “100”，
					系统可能自动分配给您100.23，您必须充值100.23系统才会自动到账，否则将不会自动入账。
				</div>
				<div class="tip-text">
					3、
					在此友情提醒，为了保证各方资金安全，将会不定期跟换银行卡，请各位玩家存款前务必登陆存款页面核实最新银行卡信息后再行存款，本平台不对错误存入失效银行卡之资金承担任何责任！
				</div>
			</div>
			<imageUSDT />
			<div class="redesign_all">
				<div class="redesign" v-for="(item, key) in payStyle" :key="item.id">
					<div class="redesign_text">{{ key }} <span> ： </span></div>
					<div class="top-up-btn-group" v-for="(item2, index) in item" :key="index" @click="choosePayStyle(key, index)">
						<div class="top-up-item" :class="{ isChecked: item2.choosed, recommend: item2.Recommend }">
							<span>
								{{ item2.PayTypeText }}
							</span>
							<span class="w100"></span>
							<span>
								{{ item2.Alias }}
							</span>
						</div>
					</div>
				</div>
				<!-- <div class="redesign" v-if="payStyle.Recommend && payStyle.Recommend.length > 0">
					<div class="redesign_text">推荐渠道：</div>
					<div
						class="top-up-btn-group"
						v-for="(item, index) in payStyle.Recommend"
						:key="index"
						@click="choosePayStyle('Recommend', index)"
					>
						<div class="top-up-item" :class="{ isChecked: item.choosed, recommend: item.Recommend }">
							<span>
								{{ item.PayTypeText }}
							</span>
							<span class="w100"></span>
							<span>
								{{ item.Alias }}
							</span>
						</div>
					</div>
				</div> -->
				<!-- <div class="redesign" v-if="payStyle.All && payStyle.All.length > 0">
					<div class="redesign_text">所有渠道：</div>
					<div
						class="top-up-btn-group"
						v-for="(item, index) in payStyle.All"
						:key="index"
						@click="choosePayStyle('All', index)"
					>
						<div class="top-up-item" :class="{ isChecked: item.choosed, recommend: item.Recommend }">
							<span>
								{{ item.PayTypeText }}
							</span>
							<span class="w100"></span>
							<span>
								{{ item.Alias }}
							</span>
						</div>
					</div>
				</div> -->
				<!-- <div class="redesign" v-if="payStyle.LT && payStyle.LT.length > 0">
					<div class="redesign_text">绿色通道：</div>
					<div
						class="top-up-btn-group"
						v-for="(item, index) in payStyle.LT"
						:key="index"
						@click="choosePayStyle('LT', index)"
					>
						<div class="top-up-item" :class="{ isChecked: item.choosed, recommend: item.Recommend }">
							<span>
								{{ item.Alias }}
							</span>
						</div>
					</div>
				</div>
				<div class="redesign" v-if="payStyle.Usdt && payStyle.Usdt.length > 0">
					<div class="redesign_text">USDT：</div>
					<div
						class="top-up-btn-group"
						v-for="(item, index) in payStyle.Usdt"
						:key="index"
						@click="choosePayStyle('Usdt', index)"
					>
						<div class="top-up-item" :class="{ isChecked: item.choosed, recommend: item.Recommend }">
							<span>
								{{ item.Alias }}
							</span>
						</div>
					</div>
				</div>
				<div class="redesign" v-if="payStyle.TBank && payStyle.TBank.length > 0">
					<div class="redesign_text">网银支付：</div>
					<div
						class="top-up-btn-group"
						v-for="(item, index) in payStyle.TBank"
						:key="index"
						@click="choosePayStyle('TB', index)"
					>
						<div class="top-up-item" :class="{ isChecked: item.choosed, recommend: item.Recommend }">
							<span>
								{{ item.Alias }}
							</span>
						</div>
					</div>
				</div>
				<div class="redesign" v-if="payStyle.TScan && payStyle.TScan.length > 0">
					<div class="redesign_text">扫码支付：</div>
					<div
						class="top-up-btn-group"
						v-for="(item, index) in payStyle.TScan"
						:key="index"
						@click="choosePayStyle('TS', index)"
					>
						<div class="top-up-item" :class="{ isChecked: item.choosed, recommend: item.Recommend }">
							<span>
								{{ item.Alias }}
							</span>
						</div>
					</div>
				</div>
				<div class="redesign" v-if="payStyle.TH5 && payStyle.TH5.length > 0">
					<div class="redesign_text">H5支付：</div>
					<div
						class="top-up-btn-group"
						v-for="(item, index) in payStyle.TH5"
						:key="index"
						@click="choosePayStyle('TH5', index)"
					>
						<div class="top-up-item" :class="{ isChecked: item.choosed, recommend: item.Recommend }">
							<span>
								{{ item.Alias }}
							</span>
						</div>
					</div>
				</div>
				<div class="redesign" v-if="payStyle.TZk && payStyle.TZk.length > 0">
					<div class="redesign_text">转卡支付：</div>
					<div
						class="top-up-btn-group"
						v-for="(item, index) in payStyle.TZk"
						:key="index"
						@click="choosePayStyle('TZk', index)"
					>
						<div class="top-up-item" :class="{ isChecked: item.choosed, recommend: item.Recommend }">
							<span>
								{{ item.Alias }}
							</span>
						</div>
					</div>
				</div> -->
			</div>

			<div class="top-up-num">
				<div class="top-up-num-text" v-show="nowIsUsdt">充值币数：</div>
				<div class="top-up-num-text" v-show="!nowIsUsdt">充值金额：</div>
				<div class="top-up-num-btn-group" style="overflow: hidden">
					<div
						class="top-up-num-item"
						:class="item.choosed ? 'isChecked' : ''"
						v-for="(item, index) in payMoneyArr"
						:key="index"
						@click="chooseMoney(index)"
					>
						{{ item.label }}<span v-show="typeof item.label == 'number'">{{ unit }}</span>
					</div>
				</div>
				<div class="top-up-num-input" v-if="showInputMoney">
					<i class="remove_num" @click="removeNum"></i>
					<el-input
						type="number"
						v-model="money"
						:placeholder="nowIsUsdt ? '请输入充值个数' : '请输入充值金额'"
						@change="changeMoney"
					></el-input>
					<i class="add_num" @click="addinputNum"></i>
					<span v-show="nowIsUsdt">{{ unit }},汇率 {{ nowUsdtReat }}={{ nowUsdtToRbm }}元</span>
					<span v-show="!nowIsUsdt">{{ unit }}</span>
					<span v-show="payTypeChoosed.Fee > 0" style="color: red; margin-left: 20px; font-size: 14px">
						温馨提示：此通道需收取{{ payTypeChoosed.Fee }}％手续费，谢谢</span
					>
				</div>
			</div>
			<div class="channelTips" v-show="payTypeChoosed.Tip">
				{{ payTypeChoosed.Tip }}
			</div>
			<div style="clear: both; padding-top: 20px">
				<el-button type="primary" class="sub-btn" @click="handleSubmit">提交订单</el-button>
			</div>
		</div>

		<!-- 提示 -->
		<dl class="prompt">
			<dd v-show="JSON.stringify(payTypeChoosed) !== '{}'">
				充值金额：单笔最低金额为{{ payTypeChoosed.MinMoney }}{{ unit }}, 最高{{ payTypeChoosed.MaxMoney }}{{ unit
				}}<span v-show="nowIsUsdt">(USDT)</span>
			</dd>
			<dd>充值时限：请在30分钟内完成充值</dd>
			<dd>充值问题请联系上级，联系不到上级，请联系客服</dd>
		</dl>

		<!-- 有未支付的绿色通道订单 -->
		<div class="no_pay" v-show="isNoPay">
			<div class="pay_head" v-if="this.minute != -1">
				***********************************订单有效时间剩余00:{{ minute }}:{{
					second
				}}***********************************
			</div>
			<div class="pay_style">
				<div>订单号码：</div>
				<el-input type="" name="" class="pay_style_mid" id="OrderNumber" v-model="noPayInfo.OrderNumber"></el-input>
				<div @click="copyText('OrderNumber')" class="copy_text">[复制]</div>
			</div>
			<div class="pay_style">
				<div>充值银行：</div>
				<div class="pay_style_mid">{{ noPayInfo.RcBankName }}</div>
				<div @click="copyText('RcBankName')" class="copy_text">[复制]</div>
				<el-input type="" name="" id="RcBankName" class="none" v-model="noPayInfo.RcBankName"></el-input>
			</div>
			<div class="pay_style">
				<div>支行名称：</div>
				<div class="pay_style_mid">{{ noPayInfo.RcBankSubbranch }}</div>
				<div @click="copyText('RcBankSubbranch')" class="copy_text">[复制]</div>
				<el-input type="" name="" id="RcBankSubbranch" class="none" v-model="noPayInfo.RcBankSubbranch"></el-input>
			</div>
			<div class="pay_style">
				<div>银行户名：</div>
				<el-input type="" name="" class="pay_style_mid" id="RcFullName" v-model="noPayInfo.RcFullName"></el-input>
				<div @click="copyText('RcFullName')" class="copy_text">[复制]</div>
			</div>
			<div class="pay_style">
				<div>银行账号：</div>
				<el-input type="" name="" class="pay_style_mid" id="RcBankNumber" v-model="noPayInfo.RcBankNumber"></el-input>
				<div @click="copyText('RcBankNumber')" class="copy_text">[复制]</div>
			</div>
			<div class="pay_style">
				<div>充值金额：</div>
				<el-input type="" name="" class="pay_style_mid" id="RandomMoney" v-model="noPayInfo.RandomMoney"></el-input>
				<div @click="copyText('RandomMoney')" class="copy_text">[复制]</div>
			</div>
			<el-button type="primary" class="go_to_bank" v-if="noPayInfo.BankUrl" @click="goToBank">前往银行</el-button>
			<div style="display: flex; justify-content: center">
				您还可以
				<span class="cancel" @click="cancelOrder">[撤销订单]</span>
				如已完成付款，请勿撤销，我们会尽快为您处理。
			</div>
		</div>
		<!-- 二维码支付弹窗 -->
		<el-dialog title="扫码完成付款" :visible.sync="dialogVisible">
			<div v-if="!showQRcodeImg" id="qrcode" ref="qrcode"></div>
			<div v-else style="display: flex; justify-content: center; align-items: center; margin-top: 36px">
				<img :src="qrcodeImg" style="width: 130px; height: 130px" />
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="qrcodeOkClose">确 定</el-button>
			</span>
		</el-dialog>

		<!-- usdt弹窗完成支付 -->
		<el-dialog
			title="USDT充值"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:visible.sync="usdtDialog.isShow"
			width="50%"
		>
			<div class="usdt_pay_result">
				<div class="one-usdt-info">
					<div class="left-lable">充值金额：</div>
					<el-input type="" name="" class="hid-input" v-model="nowUsdtToRbm"></el-input>
					<div class="copy_text"></div>
				</div>
				<div class="one-usdt-info">
					<div class="left-lable">USDT数量：</div>
					<el-input type="" name="" class="hid-input" id="UsdtCount" v-model="money"></el-input>
					<div @click="copyText('UsdtCount')" class="copy_text">[复制]</div>
				</div>
				<div class="one-usdt-info">
					<div class="left-lable">汇率：</div>
					<el-input type="" name="" class="hid-input" v-model="nowUsdtReat"></el-input>
					<div class="copy_text"></div>
				</div>
				<div class="one-usdt-info">
					<div class="left-lable">主网类型：</div>
					<el-input type="" name="" class="hid-input" v-model="usdtDialog.usdtType"></el-input>
					<div class="copy_text"></div>
				</div>
				<div class="one-usdt-info">
					<div class="left-lable">钱包地址：</div>
					<el-input type="" name="" class="hid-input" id="UsdtAddress" v-model="usdtDialog.address"></el-input>
					<div @click="copyText('UsdtAddress')" class="copy_text">[复制]</div>
				</div>
				<div class="one-usdt-info">
					<div class="left-lable">二维码：</div>
					<div class="usdtQrcode" id="usdtQrcode" ref="usdtQrcode"></div>
					<div class="copy_text"></div>
				</div>
				<div class="one-usdt-info" style="color: red">
					复制钱包地址或扫码二维码完成付款,请注意主网类型,确保转账USDT数量一致,如会员填写错误导致入账失败平台概不负责。
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="usdtOkClose">转账完成</el-button>
			</span>
		</el-dialog>

		<!-- 银行卡姓名确认弹窗 -->
		<el-dialog title="提示" :visible.sync="bankCardDialog.isShow" width="450px">
			<div style="padding: 20px">
				<div style="padding-bottom: 20px">请输入充值银行卡姓名<br />姓名与平台绑定银行卡户名不一致将无法充值</div>
				<el-input v-model="bankCardDialog.input" placeholder="请输入充值银行卡姓名"></el-input>
			</div>
			<div style="width: 100%; text-align: center">
				<el-button @click="bankCardDialog.isShow = false">取 消</el-button>
				<el-button type="primary" @click="checkBankCardName">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";
import { SysKey } from "../../util/sysconfig";
import QRCode from "qrcodejs2";
import imageUSDT from "@/components/common/imageUSDT.vue";

export default {
	components: {
		QRCode,
		imageUSDT,
	},
	data() {
		return {
			nowIsUsdt: false, //当前选择是否是usdt
			nowUsdtReat: 0, //当前选择的usdt支付方式汇率
			nowUsdtToRbm: 0, //当前汇率对应人民币
			fromData: [], //表单数据
			fromUrl: "", //表单提交链接
			qrcodeImg: "",
			showQRcodeImg: false,
			showInputMoney: true,
			dialogVisible: false,
			money: "",
			//支付渠道
			payStyle: {},
			//选中的渠道
			payTypeChoosed: {},
			//选中的渠道分类
			payTypeCategory: "",
			//充值金额数组
			payMoneyArr: [
				{ value: 500, choosed: false, label: 500 },
				{ value: 2000, choosed: false, label: 2000 },
				{ value: 5000, choosed: false, label: 5000 },
			],
			//未支付的信息
			noPayInfo: {},
			//用户信息
			userInfo: {},
			//是否有未支付的订单
			isNoPay: false,
			//接口定时器
			timer: "",
			//算时间定时器
			calcTimerL: "",
			//分钟
			minute: -1,
			//秒
			second: -1,
			newWindow: false, //聚会银浪扫码
			txwinow: "",
			usdtDialog: {
				isShow: false,
				usdtType: "", //主网类型
				address: "", //钱包地址
			},
			bankCardDialog: {
				isShow: false,
				input: "",
			},
			bankCardName: [], // 银行卡名称
			dwMin: SysKey("DwMin").SysValue,
			dwMax: SysKey("DwMax").SysValue,
			isProfileComplete: null,
		};
	},
	watch: {
		//监听金额变化转换usdt汇率
		money(val) {
			if (this.money && this.nowIsUsdt) this.nowUsdtToRbm = (parseInt(this.money) * this.nowUsdtReat).toFixed(2);
			else this.nowUsdtToRbm = 0;
		},
	},
	computed: {
		unit() {
			return this.payTypeChoosed.Rate != null ? "个" : "元";
		},
	},
	methods: {
		removeNum() {
			if (this.money > 0) {
				this.money = Number(this.money) - 1;
			}
		},
		addinputNum() {
			this.money = Number(this.money) + 1;
		},
		qrcodeOkClose() {
			this.dialogVisible = false;
			this.getUserInfo();
		},
		usdtOkClose() {
			this.usdtDialog.isShow = false;
			this.usdtDialog.address = "";
			this.usdtDialog.usdtType = "";
		},
		//得到充值通道
		getPutStyle() {
			let that = this;
			let url = "api/Cash/GetUserChargeChanelList?Term=2";
			postAjax(url, null).then(function (data) {
				if (data.IsSucess) {
					//给每个选项加上选中或未选中状态
					// if (data.Data.LT.length > 0) {
					// 	data.Data.LT = that.newputChoosed(data.Data.LT);
					// }
					// if (data.Data.TBank.length > 0) {
					// 	data.Data.TBank = that.newputChoosed(data.Data.TBank);
					// }
					// if (data.Data.TScan.length > 0) {
					// 	data.Data.TScan = that.newputChoosed(data.Data.TScan);
					// }
					// if (data.Data.TH5.length > 0) {
					// 	data.Data.TH5 = that.newputChoosed(data.Data.TH5);
					// }
					// if (data.Data.TZk.length > 0) {
					// 	data.Data.TZk = that.newputChoosed(data.Data.TZk);
					// }
					// if (data.Data.Usdt.length > 0) {
					// 	data.Data.Usdt = that.newputChoosed(data.Data.Usdt);
					// }
					that.payStyle = data.Data;
				}
			});
		},
		//新的给数组加choosed字段
		newputChoosed(arr) {
			for (var i = 0, length = arr.length; i < length; i++) {
				arr[i].choosed = false;
			}
			return arr;
		},
		//给数组加choosed字段
		putChoosed(arr) {
			for (var i = 0, length = arr.length; i < length; i++) {
				arr[i].choosed = false;
			}
		},
		//选择付款方式
		choosePayStyle(style, index) {
			this.payTypeCategory = style;

			// if (this.payStyle.LT.length > 0) {
			// 	this.putChoosed(this.payStyle.LT);
			// }
			// if (this.payStyle.TBank.length > 0) {
			// 	this.putChoosed(this.payStyle.TBank);
			// }
			// if (this.payStyle.TScan.length > 0) {
			// 	this.putChoosed(this.payStyle.TScan);
			// }
			// if (this.payStyle.TH5.length > 0) {
			// 	this.putChoosed(this.payStyle.TH5);
			// }
			// if (this.payStyle.TZk.length > 0) {
			// 	this.putChoosed(this.payStyle.TZk);
			// }
			// if (this.payStyle.Usdt.length > 0) {
			// 	this.putChoosed(this.payStyle.Usdt);
			// }
			// if (this.payStyle.Recommend.length > 0) {
			// 	this.putChoosed(this.payStyle.Recommend);
			// }
			// if (this.payStyle.All.length > 0) {
			// 	this.putChoosed(this.payStyle.All);
			// }
			for (const key in this.payStyle) {
				if (this.payStyle.hasOwnProperty(key)) {
					// 确保属性是对象的自有属性而不是继承属性
					this.putChoosed(this.payStyle[key]);
				}
			}
			this.putChoosed(this.payStyle[style]);

			this.payStyle[style][index].choosed = true;
			this.payTypeChoosed = this.payStyle[style][index];

			// switch (style) {
			// 	case "Recommend":
			// 		this.$nextTick(() => {
			// 			this.payStyle.Recommend[index].choosed = true;
			// 			this.payTypeChoosed = this.payStyle.Recommend[index];
			// 		});
			// 		break;
			// 	case "All":
			// 		this.$nextTick(() => {
			// 			this.payStyle.All[index].choosed = true;
			// 			this.payTypeChoosed = this.payStyle.All[index];
			// 		});
			// 		break;
			// 	case "LT":
			// 		this.$nextTick(() => {
			// 			this.payStyle.LT[index].choosed = true;
			// 			this.payTypeChoosed = this.payStyle.LT[index];
			// 		});
			// 		break;
			// 	case "TB":
			// 		this.$nextTick(() => {
			// 			this.payStyle.TBank[index].choosed = true;
			// 			this.payTypeChoosed = this.payStyle.TBank[index];
			// 		});
			// 		break;
			// 	case "TS":
			// 		this.$nextTick(() => {
			// 			this.payStyle.TScan[index].choosed = true;
			// 			this.payTypeChoosed = this.payStyle.TScan[index];
			// 		});
			// 		break;
			// 	case "TH5":
			// 		this.$nextTick(() => {
			// 			this.payStyle.TH5[index].choosed = true;
			// 			this.payTypeChoosed = this.payStyle.TH5[index];
			// 		});
			// 		break;
			// 	case "TZk":
			// 		this.$nextTick(() => {
			// 			this.payStyle.TZk[index].choosed = true;
			// 			this.payTypeChoosed = this.payStyle.TZk[index];
			// 		});
			// 		break;
			// 	case "Usdt":
			// 		this.$nextTick(() => {
			// 			this.payStyle.Usdt[index].choosed = true;
			// 			this.payTypeChoosed = this.payStyle.Usdt[index];
			// 			this.payMoneyArr = [
			// 				{ value: 500, choosed: false, label: 500 },
			// 				{ value: 2000, choosed: false, label: 2000 },
			// 				{ value: 5000, choosed: false, label: 5000 },
			// 				{ value: this.payTypeChoosed.MaxMoney, choosed: false, label: "最大" },
			// 			];
			// 		});
			// 		break;
			// }

			// 亿达微信扫码 特殊处理
			if (this.payStyle[style][index].ChannelType == 14) {
				this.payMoneyArr = [
					{ value: 300, choosed: false, label: 300 },
					{ value: 500, choosed: false, label: 500 },
					{ value: 800, choosed: false, label: 800 },
					{ value: 1800, choosed: false, label: 1800 },
					{ value: 2800, choosed: false, label: 2800 },
					{ value: 3800, choosed: false, label: 3800 },
					{ value: 4800, choosed: false, label: 4800 },
				];
				this.showInputMoney = false;
			} else {
				this.payMoneyArr = [
					{ value: 500, choosed: false, label: 500 },
					{ value: 2000, choosed: false, label: 2000 },
					{ value: 5000, choosed: false, label: 5000 },
				];
				this.showInputMoney = true;
			}
			//判断当前选择是否为usdt通道  PayType=90 根据这个来判断
			console.log(this.payTypeChoosed.PayType);
			if (this.payTypeChoosed.PayType == 90) {
				this.nowIsUsdt = true;
				this.nowUsdtReat = this.payStyle[style][index].Rate;
				if (this.money) this.nowUsdtToRbm = (parseInt(this.money) * this.nowUsdtReat).toFixed(2);
			} else {
				this.nowIsUsdt = false;
				this.nowUsdtReat = 0;
			}
		},
		setTimeoutFun() {
			let that = this;
			that.txwinow = window.open("");
			let img = `<div style="width:200px;height:32px;position: absolute;top: 200px; left:50%;margin-left: -100px; text-align: center;"><img src="//image.beike188.com/AMH/images/game_loading.gif"/></div><p style="font-size: 12px;text-align: center;margin-top: 280px;width: 200px;position: absolute;left: 50%;margin-left: -100px;">正在加载..</p>`;
			that.txwinow.document.body.innerHTML = "";
			that.txwinow.document.write(img);
			if (that.fromData.length > 0) {
				let str = `<form style="display: none;" action="${that.fromUrl}" method="post" ref="formSu">`;
				let forstr = "";
				that.fromData.forEach(item => {
					forstr += '<input type="text" name="' + item[0] + '" value="' + item[1] + '">';
				});
				let htmlaa = str + forstr + `</form>`;
				that.txwinow.document.body.innerHTML = "";
				that.txwinow.document.write(htmlaa);
				let frameDiv = document.createElement("script");
				frameDiv.type = "text/javascript";
				frameDiv.innerHTML = "document.querySelector('form').submit()";
				that.txwinow.document.body.appendChild(frameDiv);
			} else {
				that.setTimeout(that.setTimeoutFun, 1000);
			}
		},
		//获取绑定银行卡接口
		getBankList() {
			const that = this;
			var url = "api/Bank/GetUserBankList";
			getAjax(url).then(function (data) {
				if (data.IsSucess && data.Data.length !== 0) {
					that.bankCardName = data.Data.map(i => i.NickName);
				}
			});
		},
		// 银行卡转账 -> 姓名验证
		checkBankCardName() {
			this.bankCardDialog.isShow = false;
			this.putMoney(this.bankCardDialog.input);
		},
		// 提交订单 (ChannelType: 1 -> 银行卡转账)
		handleSubmit() {
			// const callBack = ["TZk", "LT", "All", "Recommend"].includes(this.payTypeCategory)
			// 	? () => (this.bankCardDialog.isShow = true)
			// 	: this.putMoney;
			this.bankCardDialog.isShow = true;
			this.foolproof(callBack);
		},
		// 防呆逻辑
		foolproof(callBack) {
			let that = this;

			if (JSON.stringify(this.payTypeChoosed) != "{}") {
				if (this.money) {
					if (this.money <= this.payTypeChoosed.MaxMoney && this.money >= this.payTypeChoosed.MinMoney) {
						callBack();
					} else {
						if (this.nowIsUsdt)
							that.$message.error(
								"请输入或选择" + this.payTypeChoosed.MinMoney + "-" + this.payTypeChoosed.MaxMoney + "的币数"
							);
						else
							that.$message.error(
								"请输入或选择" + this.payTypeChoosed.MinMoney + "-" + this.payTypeChoosed.MaxMoney + "的金额"
							);
					}
				} else {
					if (this.nowIsUsdt) that.$message.error("请输入或选择币数");
					else that.$message.error("请输入或选择金额");
				}
			} else {
				that.$message.error("请输入支付方式");
			}
		},
		//充值
		putMoney(Depositor = "") {
			let that = this;

			let url = "api/Cash/RechargeOrderInfo";
			let data = {
				RcKey: this.payTypeChoosed.RcKey,
				RcMoney: this.money,
				Depositor,
			};
			const loading = this.$loading({ background: "rgba(255, 255, 255, 0.2)" });
			postAjax(url, data)
				.then(function (data) {
					loading.close();
					if (data.IsSucess) {
						that.dataProcessing(data.Data);
					} else {
						that.$message.error(data.Message);
					}
				})
				.catch(() => {
					loading.close();
				});
		},
		dataProcessing(data) {
			let that = this;
			//如果为绿色通道
			if (data.ChanelType == 1) {
				//请求未支付的订单
				that.getUnFillOrder();
			} else {
				if (data.PayResult == null) {
					that.$message.error("支付渠道维护中,请联系客服!");
					return;
				}
				//新开地址跳转
				if (data.PayResult.OpType == 3) {
					that
						.$confirm("将在新窗口完成支付", "提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "success",
							center: true,
						})
						.then(() => {
							window.open(data.PayResult.Url);
						})
						.catch(() => {
							this.$message({
								type: "warning ",
								message: "已取消支付",
							});
						});
				} else if (data.PayResult.OpType == 2) {
					that.fromUrl = data.PayResult.RequestUrl;
					that.fromData = Object.entries(data.PayResult.Params);
					that
						.$confirm("将在新窗口完成支付", "提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "success",
							center: true,
						})
						.then(() => {
							that.setTimeoutFun();
						})
						.catch(() => {
							that.$message({
								type: "warning ",
								message: "已取消支付",
							});
						});
				} else if (data.PayResult.OpType == 1 || data.PayResult.OpType == 4) {
					//二维码
					that.dialogVisible = true;
					if (data.PayResult.OpType == 4) {
						that.showQRcodeImg = true;
						that.qrcodeImg = data.PayResult.QrCode;
					} else {
						//先传参
						that.showQRcodeImg = false;
						that.qrcodeImg = "";
						that.$nextTick(() => {
							that.qrcode(data.PayResult.QrCode);
						});
					}
				} //usdt 转账显示弹窗
				else if (data.PayResult.OpType == 5) {
					this.usdtDialog.usdtType = data.PayResult.UsdtType;
					this.usdtDialog.address = data.PayResult.UsdtAddress;
					this.usdtDialog.isShow = true;
					this.$nextTick(() => {
						this.usdtqrcode(this.usdtDialog.address);
					});
				}
			}
		},
		//选择金额
		chooseMoney(index) {
			if (this.payMoneyArr[index].choosed) {
				return;
			} else {
				this.putChoosed(this.payMoneyArr);
				this.payMoneyArr[index].choosed = true;
				this.money = this.payMoneyArr[index].value;
			}
		},
		//改变金额
		changeMoney(val) {
			this.putChoosed(this.payMoneyArr);
			for (var i = 0, length = this.payMoneyArr.length; i < length; i++) {
				if (val == this.payMoneyArr[i].value) {
					this.payMoneyArr[i].choosed = true;
				}
			}
		},
		//获取10分钟内未完成的订单
		getUnFillOrder() {
			let url = "api/Cash/GetUnFillRechargeOrder";
			postAjax(url, null).then(data => {
				if (data.IsSucess) {
					if (data.Data) {
						//有订单未支付
						this.noPayInfo = data.Data;
						this.noPayInfo.OrderExtendTime = parseInt(this.noPayInfo.OrderExtendTime);
						this.getResidue(this.noPayInfo.OrderExtendTime);
						this.calcTimerL = setInterval(() => {
							this.getResidue(this.noPayInfo.OrderExtendTime);
							this.noPayInfo.OrderExtendTime--;
						}, 1000);
						this.timer = setInterval(this.setTimoutCheck, 10000);
					}
				}
			});
		},
		// 得到用户信息方法
		getUserInfo() {
			let that = this;
			let url = "Api/User/GetUserInfo";
			postAjax(url, null).then(function (data) {
				if (data.IsSucess) {
					that.userInfo = data.Data;
					that.$store.commit("setUserInfo", data.Data);
				}
			});
		},
		//确定按钮
		goToBank() {
			const url = this.ensureHttps(this.noPayInfo.BankUrl);
			window.open(url);
		},
		//確保url 有https
		ensureHttps(url) {
			if (!/^https?:\/\//i.test(url)) {
				return "https://" + url;
			}
			return url;
		},
		//撤销订单
		cancelOrder() {
			let that = this;
			let url = "api/Cash/CancleRechargeOrder?OrderNumber=" + this.noPayInfo.OrderNumber;
			postAjax(url, null).then(function (data) {
				if (data.IsSucess) {
					that.$message.success("撤单成功");
					that.isNoPay = false;
					that.minute = -1;
					that.second = -1;
					clearInterval(that.timer);
					clearInterval(that.calcTimerL);
					that.timer = null;
					that.calcTimerL = null;
				} else {
					that.$message.error("撤单失败,请联系客服!");
				}
			});
		},
		//定时请求看状态是否变化
		setTimoutCheck() {
			let that = this;
			if (this.calcTimerL) {
				let url = "api/Cash/CheckRechargeOrderStatus?OrderNumber=" + this.noPayInfo.OrderNumber;
				postAjax(url, 1).then(function (data) {
					that.getUserInfo();
					if (data.IsSucess) {
						//等于2停止定时器
						if (data.Data == 1 || data.Data == 2) {
							clearInterval(that.timer);
							that.timer = null;
							that.isNoPay = false;
						}
					}
				});
			} else {
				clearInterval(this.timer);
				this.timer = null;
				that.isNoPay = false;
			}
		},
		//算剩余时间
		getResidue(time) {
			if (time >= 0) {
				this.minute = `0${parseInt(time / 60)}`.slice(-2);
				this.second = `0${parseInt(time % 60)}`.slice(-2);
				this.isNoPay = true;
			} else {
				this.minute = -1;
				this.second = -1;
				clearInterval(this.calcTimerL);
				this.calcTimerL = null;
				this.isNoPay = false;
			}
		},
		//实现复制功能
		copyText(id) {
			let url = null;
			url = document.querySelector(`#${id}`);
			url.select();
			document.execCommand("Copy");
			this.$message({
				message: "已复制",
				type: "success",
			});
		},
		//将对象序列化
		objToUrl(obj) {
			let arr = [];
			for (let key in obj) {
				arr.push(key + "=" + obj[key]);
			}
			return arr.join("&");
		},
		//生成二维码的方法
		qrcode(content) {
			//先清空
			document.getElementById("qrcode").innerHTML = "";
			let qrcode = new QRCode("qrcode", {
				width: 200, // 设置宽度，单位像素
				height: 200, // 设置高度，单位像素
				text: content, // 设置二维码内容或跳转地址
			});
		},
		//生成usdt二维码的方法
		usdtqrcode(content) {
			//先清空
			document.getElementById("usdtQrcode").innerHTML = "";
			let qrcode = new QRCode("usdtQrcode", {
				width: 250, // 设置宽度，单位像素
				height: 250, // 设置高度，单位像素
				text: content, // 设置二维码内容或跳转地址
			});
		},
		async checkProfileComplete() {
			try {
				let url = "api/Bank/IsRecharge";
				const { IsSucess, Data } = await postAjax(url);
				if (IsSucess) {
					const { Code, Message } = Data;
					const path = ["", "UserCenter?name=grzl&value=grzl", "UserCenter?name=yhkgl&value=yhkgl"];
					if (Code !== 0) {
						this.$alert(Message, "", {
							confirmButtonText: "确定",
							type: "warning",
							callback: action => {
								this.$router.push(path[Code]);
							},
						});
					}
				}
			} catch (err) {
				console.log("error", error);
			}
		},
	},
	mounted() {
		//获取10分钟内未完成的订单
		this.getUnFillOrder();
		//得到支付方式
		this.getPutStyle();
		this.getUserInfo();
		// 取得银行卡名称
		this.getBankList();
		this.checkProfileComplete();
	},
	beforeDestroy() {
		clearInterval(this.timer);
		clearInterval(this.calcTimerL);
		this.calcTimerL = null;
		this.timer = null;
	},
};
</script>
<style lang="scss">
#zhcz {
}

.none {
	position: absolute;
	left: 999999999px;
	top: 9999999999px;
}

.zhcz_main {
	padding: 20px 20px 20px 0;
}

/*提示*/
.redesign_all {
	padding-top: 25px;
}

.redesign {
	display: flex;
	align-items: start;
	flex-wrap: wrap;
	padding-left: 80px;
	margin-bottom: 10px;
}

.redesign_text {
	font-size: 14px;
	width: 80px;
	text-align: right;
	margin-left: -80px;
	padding-top: 12px;
}

#zhcz .tips {
	background-color: #f7f7f7;
}

#zhcz .usdt_pay_result {
	margin-top: 20px;
}

#zhcz .usdt_pay_result .one-usdt-info {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 20px;
}

#zhcz .usdt_pay_result .one-usdt-info .left-lable {
	width: 100px;
	text-align: right;
}

#zhcz .usdt_pay_result .one-usdt-info .hid-input {
	width: 250px;
}

#zhcz .usdt_pay_result .one-usdt-info .copy_text {
	width: 100px;
	margin-left: 5px;
	cursor: pointer;
}

#zhcz .usdt_pay_result .el-input__inner {
	font-size: 16px !important;
	padding: 0;
	line-height: 20px;
	height: 20px;
	border: 0;
	color: #333;
}

#zhcz .tip-text {
	font-size: 14px;
	margin-top: 8px;
	text-indent: -2em;
	margin-left: 2em;
}

.top-up-type,
.top-up-num {
	padding-left: 80px;
	padding-top: 5px;
	position: relative;
	clear: both;
}

.channelTips {
	padding-left: 80px;
	margin-top: 20px;
	font-size: 16px;
	color: red;
}

.top-up-text,
.top-up-num-text {
	position: absolute;
	left: 4px;
	top: 7px;
	font-size: 14px;
}

.top-up-num-text {
	left: 0;
	width: 80px;
	text-align: right;
	padding-top: 12px;
}

/*支付方式按钮*/
.top-up-item {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	width: 150px;
	/* height: 42px; */
	padding-top: 4px;
	padding-bottom: 4px;
	float: left;
	margin: 4px 12px 4px 0;
	border-radius: 5px;
	border: 1px solid #0e78c7;
	font-size: 14px;
	color: #0e78c7;
}

.top-up-item:hover {
	background-color: #e8f3f6;
}

.top-up-num-item {
	width: 80px;
	height: 42px;
	float: left;
	margin: 4px 0px 4px 0;
	text-align: center;
	border-top: 1px solid #0e78c7;
	border-bottom: 1px solid #0e78c7;
	border-left: 1px solid #0e78c7;
	line-height: 42px;
	font-size: 14px;
	color: #0e78c7;
}

.top-up-num-item:first-child {
	border-radius: 5px 0px 0px 5px;
}

.top-up-num-item:last-child {
	border-right: 1px solid #0e78c7;
	border-radius: 0 5px 5px 0px;
}

.top-up-num-item:hover {
	background-color: #e8f3f6;
}

.top-up-num-input {
	position: relative;
	margin-top: 15px;
	font-size: 16px;
}

.remove_num {
	display: inline-block;
}

i.add_num {
	background: url(../../static/img/icon/add_block.webp);
}

.top-up-num-input .remove_num {
	position: absolute;
	top: 0;
	left: 0;
	width: 34px;
	height: 42px;
	background: #e7e7e7 url(../../static/img/icon/reduce.webp) no-repeat center center/30px 30px;
	z-index: 1;
	cursor: pointer;
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px;
}

.top-up-num-input .add_num {
	position: absolute;
	top: 0;
	left: 180px;
	width: 34px;
	height: 42px;
	background: #e7e7e7 url(../../static/img/icon/add_block.webp) no-repeat center center/30px 30px;
	z-index: 1;
	cursor: pointer;
	border-top-right-radius: 5px;
	border-bottom-right-radius: 5px;
}

.top-up-num-input input:focus {
	border-color: #dcdfe6;
}

.top-up-num-input input:hover {
	border-color: #dcdfe6;
}

.top-up-num-input .el-input {
	width: 215px;
	height: 42px;
	background-color: #ffffff;
	border-radius: 5px;
}

.top-up-num-input .el-input .el-input__inner {
	text-align: center;
	width: 100%;
	height: 100%;
	padding: 0 40px;
	border: 1px solid #e7e7e8;
}

.sub-btn {
	clear: both;
	width: 216px;
	margin-left: 80px;
	font-size: 16px;
}

.isChecked {
	background: #0e78c7 !important;
	border: 0;
	color: #fff;
}

.data-no-choose {
	color: #fff;
}

/*未完成支付订单的样式*/
.no_pay {
}

.pay_head {
	text-align: center;
	padding-top: 40px;
	color: red;
	margin-bottom: 20px;
}

.pay_style {
	display: flex;
	justify-content: center;
	margin-bottom: 20px;
	align-items: center;
	height: 20px;
}

.pay_style_mid {
	width: 250px !important;
	padding-left: 50px;
	font-size: 14px;
}

.go_to_bank {
	display: block !important;
	width: 400px;
	margin: 0 auto 10px !important;
}

.cancel {
	color: #d86556;
}

.cancel:hover {
	cursor: pointer;
}

.top-up-item:hover {
	cursor: pointer;
}

.top-up-num-item:hover {
	cursor: pointer;
}

.no_pay .el-input__inner {
	font-size: 16px !important;
	padding: 0;
	line-height: 20px;
	height: 20px;
	border: 0;
	color: #333;
}

.copy_text {
	color: red;
}

/*提示弹窗样式*/
#zhcz .el-dialog__body {
	padding: 0;
}

#zhcz .el-dialog__footer {
	padding: 25px 0 60px;
	text-align: center;
}

#qrcode {
	display: flex;
	justify-content: center;
	margin-top: 20px;
}

.pay_window {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	width: 1200px;
	height: 80vh;
	margin: auto;
	z-index: 10;
}

.pay_window iframe {
	border: none;
}

#zhcz .prompt {
	border: 1px solid #f8e2b9;
	padding: 10px;
	background-color: #fffdeb;
	color: #f46e00;
	margin: 20px 50px;
}

#zhcz .prompt dt {
	height: 24px;
	line-height: 24px;
	font-weight: bold;
}

#zhcz .prompt dd {
	padding-left: 12px;
	line-height: 24px;
}

.recommend {
	position: relative;
	overflow: hidden;
}

.recommend > span {
	position: relative;
	z-index: 2;
}

.recommend:after {
	content: "推荐";
	display: block;
	position: absolute;
	top: 0;
	right: 0;
	width: 60px;
	height: 20px;
	background-color: red;
	color: #fff;
	text-align: center;
	transform: rotate(45deg) translate(13px, -8px);
}

.w100 {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AccountCenter/zhcz.vue